module.exports = __webpack_public_path__ + "img/green-tick.ee188b56.svg";